import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import _ from 'lodash';
import { Col, Container, Row, Spinner } from 'reactstrap';
import Translate, { t } from '../common/Translate';
import QuestionSlide from './QuestionSlide';
import QuestionBlock from './QuestionBlock';
import getQuestions from '../../services/Form/getQuestions';
import Block from '../common/Display/Block';
import saveValue from '../../services/Form/saveValue';
import { store } from '../../Store/store';
import getValue from '../../services/Form/getValue';
import { exclusionVehicleType } from '../../config';
import getFormLocal from '../../services/Form/getFormLocal';
import { DefaultAlertModal } from '../common/Modal/DefaultAlertModal';
import { recordHandler } from '../../config/configuration/react';

const RouteContext = React.createContext({ formId: '', sectionId: '' });

class QuestionList extends Component {
  constructor(props) {
    super(props);
    const {
      match: {
        params: { formId, sectionId, questionId },
      },
    } = this.props;
    this.formId = formId;
    this.sectionId = sectionId;
    this.questionId = questionId;

    this.state = {
      questionIndex: 0,
      questions: [],
      loading: true,
      progress: 0,
      lastQuestion: false,
      exclusionModel: false,
      exclusionReason: '',
      country: 'FR',
      recordId: null,
      loadingCountry: true,
    };
  }

  componentDidMount() {
    this.updateQuestions(this.formId, this.sectionId);
    this.getForm();
  }

  getForm = async () => {
    const f = await getFormLocal(this.formId);
    this.setState({ country: f.country, recordId: f.recordId, loadingCountry: false });
  };

  getIndex = (questions, questionId) => {
    let i = 0;
    while (i <= questions.length) {
      if (questions[i].id === questionId) return i;
      i += 1;
    }
    return 0;
  };

  getProgress() {
    const { questionIndex, questions } = this.state;
    return Math.round((questionIndex / questions.length) * 100);
  }

  updateQuestions = (formId, sectionId) => {
    this.setState({ loading: true });
    getQuestions(formId, sectionId).then((questions) => {
      let index = 0;
      if (this.questionId !== undefined) index = this.getIndex(questions, this.questionId);
      this.setState({
        questions,
        loading: false,
        questionIndex: index,
      });
    });
  };

  handleNextQuestion = () => {
    let { questionIndex } = this.state;
    const { questions } = this.state;
    if (questionIndex < questions.length - 1) {
      questionIndex += 1;
      const { id } = questions[questionIndex];
      this.changeRoute(id);
      if (questionIndex === questions.length - 1) this.setState({ lastQuestion: true });
      this.setState({ questionIndex });
    } else {
      saveValue(this.formId, `inspection.children.${this.sectionId}.lastQuestion`, null);
      this.backToSectionsList();
    }
  };

  handlePrevQuestion = () => {
    let { questionIndex } = this.state;
    const { questions } = this.state;
    if (questionIndex > 0) {
      questionIndex -= 1;
      const { id } = questions[questionIndex];
      this.changeRoute(id);
      if (questionIndex >= 0) this.setState({ lastQuestion: false });
    } else {
      this.backToSectionsList();
    }
    this.setState({ questionIndex });
  };

  toggleModal = () => {
    this.setState((prevState) => ({
      exclusionModel: !prevState.exclusionModel,
    }));
  };

  checkExclusionsNrm = async () => {
    const { recordId } = this.state;
    const originId = _.get(store.getState(), `reduxRecords.data[${recordId}].record.originId`, null);
    if ([10, 11, 12, 13, 14].includes(originId)) {
      let reason = null;
      const vehicule_type = await getValue(this.formId, 'inspection.children.admin_infos.children.vehicule_type');
      if (exclusionVehicleType.includes(vehicule_type?.[0]?.value)) reason = 'vehicleTypeExclusion';
      const tunning_car = await getValue(this.formId, 'inspection.children.admin_infos.children.tunning_car');
      if (!reason && tunning_car?.[0]?.value === 'yes') reason = 'tunningCarExclusion';
      const leasing_battery = await getValue(this.formId, 'inspection.children.admin_infos.children.leasing_battery');
      if (!reason && leasing_battery?.[0]?.value === 'yes') reason = 'leasingBatteryExclusion';
      if (reason) {
        this.setState({ exclusionReason: reason });
        this.toggleModal();
        return false;
      }
    }
    return true;
  };

  backToSectionsList = async () => {
    const redirect = await this.checkExclusionsNrm();
    if (redirect) {
      const {
        match: {
          params: { formId },
        },
        history,
      } = this.props;
      history.replace(`/forms/${formId}`);
    }
  };

  changeRoute = (id) => {
    const { history } = this.props;
    history.replace(`/forms/${this.formId}/${this.sectionId}/${id}`);
  };

  calculateProgress = () => {
    this.setState({ progress: this.getProgress() });
  };

  handleExclusion = async () => {
    const { recordId } = this.state;
    await recordHandler.updateStatus(recordId, 'refused');
    this.toggleModal();
    const { history } = this.props;
    history.push({
      pathname: `/files/${recordId}`,
    });
  };

  render() {
    let emptyQuestion;
    let questionSlide;
    const {
      match: {
        params: { formId, sectionId },
      },
    } = this.props;
    const {
      questions,
      questionIndex,
      progress,
      lastQuestion,
      loading,
      exclusionModel,
      exclusionReason,
      country,
      loadingCountry,
    } = this.state;
    const currentQuestion = questions[questionIndex];

    if (currentQuestion) {
      saveValue(formId, `inspection.children.${sectionId}.lastQuestion`, currentQuestion.id);
    }

    if (questions.length === 0) {
      emptyQuestion = (
        <Col xs="12" className="text-center">
          <Spinner color="primary" />
        </Col>
      );
    } else if (currentQuestion) {
      questionSlide = (
        <QuestionSlide
          {...this.props}
          headerTitle={t(sectionId)}
          key={currentQuestion.id}
          question={currentQuestion}
          goNextQuestion={this.handleNextQuestion}
          goPrevQuestion={this.handlePrevQuestion}
          formId={formId}
          sectionId={sectionId}
          progress={progress}
          calculateProgress={this.calculateProgress}
          lastQuestion={lastQuestion}
          country={country}
        />
      );
    }

    let content;
    if (isMobile || formId === '0') {
      content = <div>{emptyQuestion || questionSlide}</div>;
    } else {
      content = (
        <div className="question-list">
          <Block {...this.props} headerTitle={t(sectionId)} showSubHeader>
            {loading && (
              <Col xs="12" className="text-center">
                <Spinner color="primary" />
              </Col>
            )}
            <Container fluid>
              <Row className="mt-3">
                {emptyQuestion}
                {!loadingCountry &&
                  questions.map((question) => (
                    <QuestionBlock
                      {...this.props}
                      key={question.id}
                      question={question}
                      formId={formId}
                      sectionId={sectionId}
                      country={country}
                    />
                  ))}
              </Row>
              {formId !== '0' && (
                <Row className="mb-3 mt-2">
                  <Col className="text-center">
                    <button
                      type="button"
                      className="btn btn-orange"
                      data-test="validateQuestionList-btn"
                      onClick={this.backToSectionsList}
                    >
                      <Translate code="validate" />
                    </button>
                  </Col>
                </Row>
              )}
            </Container>
          </Block>
        </div>
      );
    }

    return (
      <RouteContext.Provider value={{ formId, sectionId }}>
        <>{content}</>
        {exclusionModel && (
          <DefaultAlertModal
            isOpen={exclusionModel}
            toggle={this.toggleModal}
            body={<div>{`[${t('outOfProcessPopUp')}] [${t(exclusionReason)}]`}</div>}
            cancelBtn="close"
            validateBtn="modify"
            handleCancel={this.handleExclusion}
            handleValidate={this.toggleModal}
          />
        )}
      </RouteContext.Provider>
    );
  }
}

export default QuestionList;

QuestionList.propTypes = {
  match: PropTypes.shape().isRequired,
  history: PropTypes.shape().isRequired,
};
